import ListItemIcon from "@material-ui/core/ListItemIcon";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles(() => ({
  item: {
    overflow: "visible",
  },
  submenu: {
    position: "absolute",
    top: "-8px",
    right: "100%",
    paddingTop: "8px",
    paddingBottom: "8px",
    background: "#fff",
    borderRadius: "4px",
    boxShadow:
      "-2px 5px 5px -3px rgb(0 0 0 / 20%), -3px 8px 10px 1px rgb(0 0 0 / 14%), 0px 0px 5px 1px rgb(0 0 0 / 12%)",
    visibility: "hidden",
    opacity: 0,
  },
  submenuActive: {
    visibility: "visible",
    opacity: 1,
  },
  arrowIcon: {
    marginLeft: "14px",
  },
}));

function TableMenuItemMenu(props) {
  const classes = useStyles();
  const { option } = props;

  const [openSubmenu, setOpenSubmenu] = React.useState(false);

  return (
    <MenuItem
      className={classes.item}
      onMouseEnter={() => setOpenSubmenu(true)}
      onMouseLeave={() => setOpenSubmenu(false)}
    >
      {option.icon && (
        <ListItemIcon>
          <option.icon fontSize="small" />
        </ListItemIcon>
      )}
      <Typography>{option.label}</Typography>
      <ArrowRightIcon className={classes.arrowIcon} />
      {/* submenu */}
      <div
        className={clsx(classes.submenu, {
          [classes.submenuActive]: openSubmenu,
        })}
      >
        {option.menu.map((submenuOption) => (
          <MenuItem
            onClick={() => {
              props.onCloseMenu();
              submenuOption.onClick(props.data);
            }}
          >
            <Typography>{submenuOption.label}</Typography>
          </MenuItem>
        ))}
      </div>
      {/* end submenu */}
    </MenuItem>
  );
}

TableMenuItemMenu.defaultProps = {
  onCloseMenu: () => {},
  data: null,
};

TableMenuItemMenu.propTypes = {
  option: PropTypes.object.isRequired,
  data: PropTypes.object,
  onCloseMenu: PropTypes.func,
};

export default TableMenuItemMenu;
